import { render, staticRenderFns } from "./Restoration.vue?vue&type=template&id=4c219d52"
import script from "./Restoration.vue?vue&type=script&lang=js"
export * from "./Restoration.vue?vue&type=script&lang=js"
import style0 from "./Restoration.vue?vue&type=style&index=0&id=4c219d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports